import { msgs } from "../define";

/** WP08: native app (Android/iPad) — device settings, server setting, app lock, offline, camera, notifications. */
export const mobile = msgs({
  en: {
    "mob.offline.banner": "You're offline. You can keep looking, but checkout is paused until the connection is back.",
    "mob.offline.payment": "You're offline. Payments are never saved for later — reconnect to take this payment.",
    "mob.offline.payTitle": "No connection — checkout paused",
    "mob.server.title": "Server",
    "mob.server.confirmTitle": "Change the server?",
    "mob.server.confirm": "This setting is for the salon's administrator. Changing the server signs this device out. Continue?",
    "mob.server.url": "Server address",
    "mob.server.hint": "The https:// address of your Senvia POS server, e.g. https://app.yoursalon.com",
    "mob.server.test": "Test connection",
    "mob.server.save": "Save and restart",
    "mob.server.reset": "Use the default server",
    "mob.server.ok": "Connected to {host}.",
    "mob.server.fail": "Couldn't reach a Senvia POS server at this address.",
    "mob.server.err.https": "The address must start with https:// (plain http is only allowed for localhost in development).",
    "mob.server.err.invalid": "That doesn't look like a web address.",
    "mob.server.err.path": "Enter only the server address — no path, query or login details.",
    "mob.server.current": "Current server: {url}",
    "mob.server.default": "default",
    "mob.lock.title": "Senvia POS is locked",
    "mob.lock.body": "Use your fingerprint, face or the device PIN to continue.",
    "mob.lock.unlock": "Unlock",
    "mob.lock.reason": "Unlock Senvia POS",
    "mob.lock.signOut": "Sign out instead",
    "mob.device.title": "This device",
    "mob.device.lock": "App lock",
    "mob.device.lockHelp": "Ask for fingerprint, face or the device PIN when the app comes back from the background.",
    "mob.device.lockNoSecure": "This device has no screen lock, so the app can't lock itself. Set a PIN in the device settings.",
    "mob.device.lockAfter": "Lock after",
    "mob.device.immediately": "Immediately",
    "mob.device.minutes": "{n} min in the background",
    "mob.device.kiosk": "Shared tablet",
    "mob.device.kioskHelp": "When kiosk mode is on (account menu), the app returns to the staff PIN screen instead, so each team member switches in with their own PIN.",
    "mob.device.push": "Notifications",
    "mob.device.pushHelp": "New online bookings, cancellations, approval requests and failed refunds.",
    "mob.device.pushOn": "On for this device",
    "mob.device.pushOff": "Off",
    "mob.device.pushDenied": "Notifications are blocked. Allow them for Senvia POS in the device settings.",
    "mob.device.pushBuild": "Not available in this build (Firebase isn't set up yet).",
    "mob.device.pushServer": "The server has no push credentials yet, so nothing will arrive.",
    "mob.device.pushEnable": "Turn on notifications",
    "mob.device.server": "Server",
    "mob.device.version": "App version",
    "mob.device.subscription": "Plans and billing are managed by the salon owner on the web.",
    "mob.photo.take": "Take after-photo",
    "mob.photo.library": "Choose from library",
    "mob.photo.saved": "Photo saved — visible to the salon team only.",
    "mob.photo.denied": "Camera access is blocked. Allow it for Senvia POS in the device settings.",
    "mob.photo.forCustomer": "After-photo · {name}",
    "mob.receipt.open": "Print / save PDF",
    "mob.receipt.openHint": "Opens the receipt in the browser, where you can print or share it.",
    "mob.push.received": "{title}: {body}",
    "mob.back.exitHint": "Press back again to close the app",
    "mob.setupOnWeb": "Finish setting up your salon in the web app first, then sign in here.",
  },
  zh: {
    "mob.offline.banner": "当前离线。您仍可浏览，但收银已暂停，网络恢复后才可继续。",
    "mob.offline.payment": "当前离线。付款绝不会被保存待稍后处理——请恢复网络后再收款。",
    "mob.offline.payTitle": "无网络——收银已暂停",
    "mob.server.title": "服务器",
    "mob.server.confirmTitle": "要更换服务器吗？",
    "mob.server.confirm": "此设置供店铺管理员使用。更换服务器会让本设备退出登录。是否继续？",
    "mob.server.url": "服务器地址",
    "mob.server.hint": "您的 Senvia POS 服务器 https:// 地址，例如 https://app.yoursalon.com",
    "mob.server.test": "测试连接",
    "mob.server.save": "保存并重启",
    "mob.server.reset": "使用默认服务器",
    "mob.server.ok": "已连接到 {host}。",
    "mob.server.fail": "无法在此地址找到 Senvia POS 服务器。",
    "mob.server.err.https": "地址必须以 https:// 开头（仅开发环境的 localhost 可用 http）。",
    "mob.server.err.invalid": "这看起来不是有效的网址。",
    "mob.server.err.path": "只需输入服务器地址——不要包含路径、查询参数或登录信息。",
    "mob.server.current": "当前服务器：{url}",
    "mob.server.default": "默认",
    "mob.lock.title": "Senvia POS 已锁定",
    "mob.lock.body": "请使用指纹、面容或设备密码继续。",
    "mob.lock.unlock": "解锁",
    "mob.lock.reason": "解锁 Senvia POS",
    "mob.lock.signOut": "改为退出登录",
    "mob.device.title": "本设备",
    "mob.device.lock": "应用锁",
    "mob.device.lockHelp": "应用从后台返回时，要求指纹、面容或设备密码。",
    "mob.device.lockNoSecure": "本设备未设置屏幕锁，应用无法自动上锁。请在设备设置中设置密码。",
    "mob.device.lockAfter": "上锁时间",
    "mob.device.immediately": "立即",
    "mob.device.minutes": "在后台 {n} 分钟后",
    "mob.device.kiosk": "共用平板",
    "mob.device.kioskHelp": "开启共用模式（账户菜单）后，应用返回时会显示员工 PIN 画面，每位员工用自己的 PIN 切换。",
    "mob.device.push": "通知",
    "mob.device.pushHelp": "新的网上预约、取消、审批请求和退款失败。",
    "mob.device.pushOn": "本设备已开启",
    "mob.device.pushOff": "关闭",
    "mob.device.pushDenied": "通知已被阻止。请在设备设置中允许 Senvia POS 发送通知。",
    "mob.device.pushBuild": "此版本不支持（尚未设置 Firebase）。",
    "mob.device.pushServer": "服务器尚未配置推送凭证，因此不会收到通知。",
    "mob.device.pushEnable": "开启通知",
    "mob.device.server": "服务器",
    "mob.device.version": "应用版本",
    "mob.device.subscription": "方案与账单由店主在网页版管理。",
    "mob.photo.take": "拍摄完成照",
    "mob.photo.library": "从相册选择",
    "mob.photo.saved": "照片已保存——仅店内团队可见。",
    "mob.photo.denied": "相机权限被阻止。请在设备设置中允许 Senvia POS 使用相机。",
    "mob.photo.forCustomer": "完成照 · {name}",
    "mob.receipt.open": "打印 / 保存 PDF",
    "mob.receipt.openHint": "在浏览器中打开收据，可打印或分享。",
    "mob.push.received": "{title}：{body}",
    "mob.back.exitHint": "再按一次返回键关闭应用",
    "mob.setupOnWeb": "请先在网页版完成店铺设置，然后再在这里登录。",
  },
  ms: {
    "mob.offline.banner": "Anda di luar talian. Anda masih boleh melihat, tetapi pembayaran dijeda sehingga sambungan pulih.",
    "mob.offline.payment": "Anda di luar talian. Bayaran tidak sekali-kali disimpan untuk kemudian — sambung semula untuk menerima bayaran ini.",
    "mob.offline.payTitle": "Tiada sambungan — pembayaran dijeda",
    "mob.server.title": "Pelayan",
    "mob.server.confirmTitle": "Tukar pelayan?",
    "mob.server.confirm": "Tetapan ini untuk pentadbir salon. Menukar pelayan akan mendaftar keluar peranti ini. Teruskan?",
    "mob.server.url": "Alamat pelayan",
    "mob.server.hint": "Alamat https:// pelayan Senvia POS anda, cth. https://app.salonanda.com",
    "mob.server.test": "Uji sambungan",
    "mob.server.save": "Simpan dan mula semula",
    "mob.server.reset": "Guna pelayan lalai",
    "mob.server.ok": "Bersambung ke {host}.",
    "mob.server.fail": "Tidak dapat mencapai pelayan Senvia POS di alamat ini.",
    "mob.server.err.https": "Alamat mesti bermula dengan https:// (http biasa hanya dibenarkan untuk localhost semasa pembangunan).",
    "mob.server.err.invalid": "Itu tidak kelihatan seperti alamat web.",
    "mob.server.err.path": "Masukkan alamat pelayan sahaja — tanpa laluan, pertanyaan atau butiran log masuk.",
    "mob.server.current": "Pelayan semasa: {url}",
    "mob.server.default": "lalai",
    "mob.lock.title": "Senvia POS dikunci",
    "mob.lock.body": "Gunakan cap jari, wajah atau PIN peranti untuk meneruskan.",
    "mob.lock.unlock": "Buka kunci",
    "mob.lock.reason": "Buka kunci Senvia POS",
    "mob.lock.signOut": "Daftar keluar sahaja",
    "mob.device.title": "Peranti ini",
    "mob.device.lock": "Kunci aplikasi",
    "mob.device.lockHelp": "Minta cap jari, wajah atau PIN peranti apabila aplikasi kembali dari latar belakang.",
    "mob.device.lockNoSecure": "Peranti ini tiada kunci skrin, jadi aplikasi tidak dapat mengunci dirinya. Tetapkan PIN dalam tetapan peranti.",
    "mob.device.lockAfter": "Kunci selepas",
    "mob.device.immediately": "Serta-merta",
    "mob.device.minutes": "{n} min di latar belakang",
    "mob.device.kiosk": "Tablet kongsi",
    "mob.device.kioskHelp": "Apabila mod kiosk dihidupkan (menu akaun), aplikasi kembali ke skrin PIN kakitangan, supaya setiap kakitangan bertukar dengan PIN sendiri.",
    "mob.device.push": "Pemberitahuan",
    "mob.device.pushHelp": "Tempahan dalam talian baharu, pembatalan, permintaan kelulusan dan bayaran balik yang gagal.",
    "mob.device.pushOn": "Dihidupkan untuk peranti ini",
    "mob.device.pushOff": "Mati",
    "mob.device.pushDenied": "Pemberitahuan disekat. Benarkan untuk Senvia POS dalam tetapan peranti.",
    "mob.device.pushBuild": "Tidak tersedia dalam binaan ini (Firebase belum disediakan).",
    "mob.device.pushServer": "Pelayan belum mempunyai kelayakan push, jadi tiada apa yang akan tiba.",
    "mob.device.pushEnable": "Hidupkan pemberitahuan",
    "mob.device.server": "Pelayan",
    "mob.device.version": "Versi aplikasi",
    "mob.device.subscription": "Pelan dan bil diurus oleh pemilik salon di web.",
    "mob.photo.take": "Ambil foto selepas",
    "mob.photo.library": "Pilih dari galeri",
    "mob.photo.saved": "Foto disimpan — hanya kelihatan kepada pasukan salon.",
    "mob.photo.denied": "Akses kamera disekat. Benarkan untuk Senvia POS dalam tetapan peranti.",
    "mob.photo.forCustomer": "Foto selepas · {name}",
    "mob.receipt.open": "Cetak / simpan PDF",
    "mob.receipt.openHint": "Membuka resit dalam pelayar, di mana anda boleh mencetak atau berkongsi.",
    "mob.push.received": "{title}: {body}",
    "mob.back.exitHint": "Tekan kembali sekali lagi untuk menutup aplikasi",
    "mob.setupOnWeb": "Selesaikan persediaan salon anda dalam aplikasi web dahulu, kemudian log masuk di sini.",
  },
});
